/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';

import { NotFoundPage } from '@vlabs/uikit/pages/not-found-page/NotFoundPage';
import { useTranslation } from 'react-i18next';

import { CardListPage } from '../point/cards/CardListPage';
import { ListListPage } from '../list-list-page';
import { PageTabSelector, useActivePageTab } from './page-tab-selector';

export function CardsAndListsPage(): React.JSX.Element {
  const { t } = useTranslation();
  const activeTab = useActivePageTab();

  switch (activeTab) {
    case 'cards': return <CardListPage title={t('cards-and-lists:title')} titleItems={<PageTabSelector />} />;
    case 'lists': return <ListListPage title={t('cards-and-lists:title')} titleItems={<PageTabSelector />} />;
    default: return <NotFoundPage />;
  }
}
